var ChatterBarView = Backbone.View.extend({
    tagName: 'div',
    className: 'extras',
    initialize: function (options) {
        this.timeagoStrings = $.extend(true, {}, $.timeago.settings.strings);
        this.timeagoStrings.prefixAgo = null;
        this.timeagoStrings.suffixAgo = null;
        this.timeagoStrings.prefixFromNow = null;
        this.timeagoStrings.suffixFromNow = null;
        
        this.visible = false;
        this.mentionsVisible = true;
        
        this.model.bind('remove', this.remove, this);
    },
    render: function () {
        this.mentionsBadge = $('<span class="extrasBadge">');
        this.mentionsText = $('<span>');
        this.mentions = $('<span>').append(this.mentionsBadge, this.mentionsText);
        var timeUnknown = $('<span>');
        var timeKnown = $('<span>');
        this.time = timeUnknown.add(timeKnown);
        this.unknownLines = $('<span>').append(timeUnknown, ' of unread messages');
        this.lines = $('<span>');
        this.linesS = $('<span>');
        this.knownLines = $('<span>').append(
            this.lines,
            ' unread message',
            this.linesS,
            ' (', timeKnown, ')'
        );
        this.extrasButton = $('<span class="extrasButton">').text(this.buttonText);
        this.button = $('<span class="extrasBar">').append(
            this.extrasButton, ' ',
            this.mentions,
            this.knownLines,
            this.unknownLines
        );
        $(this.el).append(this.button);
        
        return this;
    },
    isVisible: function () {
        return this.visible;
    },
    show: function () {
        if (!this.isVisible()) {
            $(this.el).show();
            this.visible = true;
            return true;
        }
    },
    hide: function () {
        if (this.isVisible()) {
            $(this.el).hide();
            this.visible = false;
            return true;
        }
    },
    renderChatter: function (time, lines) {
        if (lines) {
            // Check how much chatter is unseen (time)
            var timeago = $.timeago(time, this.timeagoStrings);
            if (timeago != this.lastTimeago) {
                this.lastTimeago = timeago;
                this.time
                    .text(timeago)
                    .attr('title', time.formatFullDate());
            }
            if (lines !== true) {
                var s = lines === 1 ? '' : 's';
                this.lines.text(lines);
                this.linesS.text(s);
            }
            this.knownLines.toggle(lines !== true);
            this.unknownLines.toggle(lines === true);
            return this.show();
        } else {
            return this.hide();
        }
    },
    hideMentions: function () {
        this.mentionsText.text('');
        this.mentionsBadge.text('');
        if (this.mentionsVisible) {
            this.mentions.hide();
            this.mentionsVisible = false;
        }
    },
    showMentions: function () {
        if (!this.mentionsVisible) {
            this.mentions.show();
            this.mentionsVisible = true;
        }
    },
    renderMentions: function (length) {
        if (length) {
            // Unseen highlights
            this.mentionsBadge.text(length);
            var s = length === 1 ? '' : 's';
            this.mentionsText.text(' mention' + s + ' and ');
            this.showMentions();
        } else {
            this.hideMentions();
        }
    }
});


module.exports = ChatterBarView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/chatterbarview.js
// module id = hKI7
// module chunks = 1